// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_js":"99f2d7eec1f8e9b7","node_modules_canvg_lib_index_es_js":"aeb72bb0c4f5730e","src_app_components_widget_status-overview_page-popup_page-popup_component_ts":"f62c2fd4cfb25164"}[chunkId] + ".js";
};